// Vendors
import React, { createContext, useContext, useState } from 'react';
// Enumerations
import { UploadIdStatesEnumeration } from '../enumerations/upload-id-states.enumeration';
// Hooks
import { useAppContextConsumerHook } from 'contexts/app.context';
// Types
import {
  UploadIdContextType,
  UploadIdVerificationInformationType,
} from './types/upload-id.contexts.type';
// Utils
import { getUploadIdFromCurrentState } from './utils/upload-id.context.utils';

const UploadIdContext = createContext<UploadIdContextType>({} as UploadIdContextType);

const UploadIdContextProvider = ({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement => {
  const { currentState } = useAppContextConsumerHook();

  const [verificationInformation, setVerificationInformation] =
    useState<UploadIdVerificationInformationType>(null);
  const [uploadIdState, setUploadIdState] = useState<UploadIdStatesEnumeration>(
    getUploadIdFromCurrentState(currentState)
  );
  
  return (
    <UploadIdContext.Provider
      value={{
        setUploadIdState,
        setVerificationInformation,
        verificationInformation,
        uploadIdState,
      }}
    >
      {children}
    </UploadIdContext.Provider>
  );
};

const useUploadIdContextConsumerHook = (): UploadIdContextType => useContext(UploadIdContext);

/* eslint-disable */
const UploadIdContextConsumerHOC =
  (Component: React.FunctionComponent<any>): React.FunctionComponent<any> =>
  (props: any): React.ReactElement<React.Provider<any>> =>
    (
      <UploadIdContextProvider>
        <Component {...props} />
      </UploadIdContextProvider>
    );

export { useUploadIdContextConsumerHook, UploadIdContextConsumerHOC, UploadIdContextProvider };
